import { render, staticRenderFns } from "./queryTypeModal.vue?vue&type=template&id=0bbf7ae7&scoped=true&"
import script from "./queryTypeModal.vue?vue&type=script&lang=js&"
export * from "./queryTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./queryTypeModal.vue?vue&type=style&index=0&id=0bbf7ae7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf7ae7",
  null
  
)

export default component.exports